"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asynchronizer = void 0;
class Asynchronizer {
    constructor() {
        this.promises = [];
        this.threshold = 5;
    }
    cleanPromises() {
        this.promises = [];
    }
    setThreshold(count) {
        this.threshold = count;
    }
    async addAndWait(promise, onCatchFunc = err => 0) {
        this.promises.push(promise.catch(err => onCatchFunc(err)));
        if (this.promises.length >= this.threshold) {
            await Promise.all(this.promises);
            this.cleanPromises();
        }
    }
    async waitForRemainigPromises() {
        await Promise.all(this.promises);
        this.cleanPromises();
    }
    remainigPromises() {
        return this.promises;
    }
}
exports.Asynchronizer = Asynchronizer;
//# sourceMappingURL=asynchronizer.js.map